import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button,
  LinearProgress,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const DistributorTable = props => {
  const { 
    className, 

    userRole,

    distributors, 
    onSetSelectedDistributors,
    onClickOpenRegister,
    onClickOpenEdit,
    onClickOpenDelete,
    disableEditButton,
    disableDeleteButton,
    
    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest } = props;

  const classes = useStyles();

  const [selectedDistributors, setSelectedDistributors] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedDistributors;

    if (event.target.checked) {
      selectedDistributors = distributors.map(distributor => distributor.id);
    } else {
      selectedDistributors = [];
    }

    setSelectedDistributors(selectedDistributors);
    onSetSelectedDistributors(selectedDistributors);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedDistributors.indexOf(id);
    let newSelectedDistributors = [];

    if (selectedIndex === -1) {
      newSelectedDistributors = newSelectedDistributors.concat(selectedDistributors, id);
    } else if (selectedIndex === 0) {
      newSelectedDistributors = newSelectedDistributors.concat(selectedDistributors.slice(1));
    } else if (selectedIndex === selectedDistributors.length - 1) {
      newSelectedDistributors = newSelectedDistributors.concat(selectedDistributors.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedDistributors = newSelectedDistributors.concat(
        selectedDistributors.slice(0, selectedIndex),
        selectedDistributors.slice(selectedIndex + 1)
      );
    }

    setSelectedDistributors(newSelectedDistributors);
    onSetSelectedDistributors(newSelectedDistributors);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  // };


  // const [openAlert, setOpenAlert] = useState(false);

  // const handleClickOpenAlert = () => {
  //   setOpenAlert(true);
  // };

  // const handleCloseAlert = () => {
  //   setOpenAlert(false);
  // };


  useEffect(() => {
    //console.log('componentDidUpdate & distributors changed -> ' + distributors.length);

    const newSelected = selectedDistributors.filter(id => {
      const findObj = distributors.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedDistributors(newSelected);
    onSetSelectedDistributors(newSelected);

  }, [distributors]);

  return (
    <div>

      {userRole !== 'user' && (
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegister }
          >
            등록
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEdit }
          >
            수정
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDelete }
          >
            삭제
          </Button>

        </div>
      )}

      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {openProgress && <LinearProgress /> }
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={distributors.length > 0 && selectedDistributors.length === distributors.length}
                        color="primary"
                        indeterminate={
                          selectedDistributors.length > 0 &&
                          selectedDistributors.length < distributors.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>번호</TableCell>
                    <TableCell>대리점명</TableCell>
                    <TableCell>거래담당자</TableCell>
                    <TableCell>전화번호</TableCell>
                    <TableCell>등록일</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {distributors.slice(0, rowsPerPage).map((distributor, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={distributor.id}
                      selected={selectedDistributors.indexOf(distributor.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedDistributors.indexOf(distributor.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, distributor.id)}
                          value="true"
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          {/* <Avatar
                            className={classes.avatar}
                            src={category.avatarUrl}
                          >
                            {getInitials(category.name)}
                          </Avatar> */}
                          <Typography variant="body1">{distributor.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{distributor.manager}</TableCell>
                      <TableCell>{distributor.tel}</TableCell>
                      <TableCell>
                        {moment(distributor.reg_at).format('YYYY-MM-DD')}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            labelRowsPerPage=''
            component="div"
            count={item_total}
            onChangePage={onPageChange}
            onChangeRowsPerPage={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>

    </div>
  );
};

DistributorTable.propTypes = {
  className: PropTypes.string,
  distributors: PropTypes.array.isRequired
};


DistributorTable.defaultProps = {
  distributors: [],
};


export default DistributorTable;
